/**
 * ? @description : Overall Unmapped Tab Data Component
 */

// Dependencies
import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

// Modals Components
import UnmappedTeachersTable from "./modals/UnmappedTeachersTable";
import UnmappedStudentsTable from "./modals/UnmappedStudentsTable";
import MappedDataModal from "./modals/MappedDataModal";

// Redux Component
import { showSnackbar } from "../../../redux/features/appSlice";
import Axios from "../../../../axios/Axios";
import axios from "axios";


function UnmappedTab() {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [unmappedTeachersData, setUnmappedTeachersData] = useState([]);
  const [unmappedStudentsData, setUnmappedStudentsData] = useState([]);
  const [mappedTeachersValues, setMappedTeachersValues] = useState([]);
  const [mappedStudentsValues, setMappedStudentsValues] = useState([]);
  const [mappedValues, setMappedValues] = useState([]);
  const [mappingModal, setMappingModal] = useState(false);
  const [reloadComments, setReloadComments] = useState(false);

  const handleCommentsModalClose = () => {
    setReloadComments(!reloadComments);
};
  //Function to check if the teacher is already mapped to the student
  function checkIfTeacherAlreadyMappedToStudent(mappedArray){
    const controller = axios.CancelToken.source();

    return mappedArray.map(async (mapObj) => {
      const response = await Axios("get", `mapping/map/checkmappingteacher/${mapObj.teacherId}`, true, null,{cancelToken: controller.token}
      );
      const isTeacherMappedtoStudent = Array.isArray(response.data.resultdata) ? response.data.resultdata.some(data => data.student_id === mapObj.studentId) : false;
      return isTeacherMappedtoStudent;
  
    });
  
    // console.log(temp);
    // console.log(temp);
  }

  // ! Function for Mapping Logic
  const createMapping = async () => {
    if (unmappedTeachersData.length > 0 && unmappedStudentsData.length > 0) {
      // Data Initialization
      let teachers = unmappedTeachersData;
      let students = unmappedStudentsData;

      // Variables Declaration
      let teacherArrayValues = [];
      let studentArrayValues = [];
      let mappedArrayValues = [];
      let mappedTeacherArrayValues = [];
      let mappedStudentArrayValues = [];

      // Array method : forEach Function - teachers
      teachers.forEach(myLanguages_1);
      function myLanguages_1(value, index) {
        let tempArray = value.teacherlanguages.split(",");
        let teacherObject = {
          lang: tempArray,
          name: value.teacher_name,
          id: value.teacher_id,
          // batchId: value.teacher_batch_list[0].batch_ids,
          // batchName: value.teacher_batch_list[0].batch_name,
          teacherBatchLists: value.teacher_batch_list
        };
        teacherArrayValues.push(teacherObject); 
      }

      // Array method : forEach Function - Students
      students.forEach(myLanguages_2);
      function myLanguages_2(value, index) {
        let tempArray = value.studentlanguages.split(",");
        let studentObject = {
          lang: tempArray,
          name: value.student_name,
          id: value.student_id,
        };
        studentArrayValues.push(studentObject);
      }

      // Iterating Teachers & Students Values through for-loop Condition
      for (let i = 0; i < studentArrayValues.length; i++) {
        for (let j = 0; j < teacherArrayValues.length; j++) {
          let mappedObjectValue = {};
          let mappedTeacherValues = {};
          let mappedStudentValues = {};

          // Converting Students Languages Value to LowerCase
          let stuLang = studentArrayValues[i].lang;
          let studLanguageOutput = stuLang.map((langs) => langs.toLowerCase());

          // Converting Teachers Languages Value to LowerCase
          let teachLang = teacherArrayValues[j].lang;
          let teachLanguageOutput = teachLang.map((langs) =>
            langs.toLowerCase()
          );

          // Filtering the Common Languages
          let tempLanguages = studLanguageOutput
            .filter((e) => teachLanguageOutput.includes(e))
            .join(", ");

          if (tempLanguages.length > 0) {
            // mappedObjectValue.uid = nanoid();
            mappedObjectValue.studentName = studentArrayValues[i].name;
            mappedObjectValue.studentId = studentArrayValues[i].id;
            mappedObjectValue.teacherName = teacherArrayValues[j].name;
            mappedObjectValue.teacherId = teacherArrayValues[j].id;
            // mappedObjectValue.teacherBatchId = teacherArrayValues[j].batchId;
            // mappedObjectValue.teacherBatchName = teacherArrayValues[j].batchName;
            mappedObjectValue.teacherBatchLists = teacherArrayValues[j].teacherBatchLists;
            /********** */
            // mappedObjectValue.teacherBatchLists = [
            //   {name: "First batch", id: 38}, 
            //   {name: "Second batch", id: 39}, 
            //   {name: "Third batch", id: 40}, 
            // ]
            /********** */
            mappedObjectValue.commonLanguages = tempLanguages;
            mappedObjectValue.teacherRole = "Teacher";
            mappedObjectValue.studentRole = "Student";

            mappedTeacherValues.teacherName = teacherArrayValues[j].name;
            mappedTeacherValues.teacherId = teacherArrayValues[j].id;
            mappedTeacherValues.commonLanguages = tempLanguages;
            mappedTeacherValues.role = "Teacher";

            mappedStudentValues.studentName = studentArrayValues[i].name;
            mappedStudentValues.studentId = studentArrayValues[i].id;
            mappedStudentValues.commonLanguages = tempLanguages;
            mappedStudentValues.role = "Student";
          }

          // if (tempLanguages.length > 0) {
          //   mappedTeacherValues.teacherName = teacherArrayValues[j].name;
          //   mappedTeacherValues.teacherId = teacherArrayValues[j].id;
          //   mappedTeacherValues.commonLanguages = tempLanguages;
          //   mappedTeacherValues.role = "Teacher";
          // }

          // if (tempLanguages.length > 0) {
          //   mappedStudentValues.studentName = studentArrayValues[i].name;
          //   mappedStudentValues.studentId = studentArrayValues[i].id;
          //   mappedStudentValues.commonLanguages = tempLanguages;
          //   mappedStudentValues.role = "Student";
          // }

          mappedArrayValues.push(mappedObjectValue);
          mappedTeacherArrayValues.push(mappedTeacherValues);
          mappedStudentArrayValues.push(mappedStudentValues);
        }
      }

      // Remove Empty Pair Values
      for (let k = 0; k < mappedArrayValues.length; k++) {
        const isEmptyValues = Object.keys(mappedArrayValues[k]).length === 0;

        if (isEmptyValues) {
          mappedArrayValues.splice(k, 1);
          k--;
        }
      }

      setMappedValues(mappedArrayValues);
      setMappedTeachersValues(mappedTeacherArrayValues);
      setMappedStudentsValues(mappedStudentArrayValues);
      
      // ? Alert User When No Mapping is Found ( nothing to show data )
      // const isEmpty = Object.keys(mappedValues).length === 0;
      if (mappedArrayValues.length === 0) {
        dispatch(
          showSnackbar({
            message: "No common languages found, Please try again.",
            severity: "error",
          })
        );
      } else {
          // Modal Open
          const isTeacherMappedToStudent = await Promise.all(await checkIfTeacherAlreadyMappedToStudent(mappedArrayValues)).then(teacherStatus => {
            // console.log(teacherStatus);
            return teacherStatus.some(data => data); 
            // setMappingModal(true);
          })
          if(isTeacherMappedToStudent){
            dispatch(showSnackbar({
              message: "The teacher you selected is already mapped to one of the selected students, Please unselect the teacher and try again",
              severity: "error",
            }))
          }else{
            setMappingModal(true)
          }
      }
    } else {
      dispatch(
        showSnackbar({
          message:
            "Please select atleast one profile in both the tables to initiate system mapping !",
          severity: "error",
        })
      );
    }
  };
  
  return (
    <div>
      {/* Button */}
      <div className="m-3 d-flex justify-content-end">
        <Button type="button" variant="primary" onClick={createMapping}>
          Create Mapping
        </Button>
      </div>

      {/* Table */}
      <Row style={{ margin: "0px 5px" }}>
        <Col
          style={{ border: "1px solid #D6D6D6" }}
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          xxl={6}
        >
          <UnmappedTeachersTable
          reloadComments={reloadComments}
            unmappedteachersdata={setUnmappedTeachersData}
          />
        </Col>
        <Col
          style={{ border: "1px solid #D6D6D6" }}
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          xxl={6}
        >
          <UnmappedStudentsTable
           reloadComments={reloadComments}
            unmappedstudentsdata={setUnmappedStudentsData}
          />
        </Col>
      </Row>

      {/* Mapped Data Modal */}
      <MappedDataModal
        show={mappingModal}
        onHide={() => setMappingModal(false)}
        mappedvalues={mappedValues}
        setMappedValues={setMappedValues}
        mappedteachersvalues={mappedTeachersValues}
        mappedstudentsvalues={mappedStudentsValues}
        onCloseCallback={handleCommentsModalClose}
      />
    </div>
  );
}

export default UnmappedTab;
